import React from "react";
import app from "../app";
import { LegalIntro } from "../components/GatewayForm/steps/legal";

function LegalAdvice() {
  return (
    <>
      {/* <GatewayForm /> */}
      <LegalIntro />
    </>
  );
}

const LegalAdviceApp = app(LegalAdvice);
export default LegalAdviceApp;
